import axios from "axios";
import Config from "../../../config/index";
// import {
//   GET_GRN_REPORT_DOWNLOAD_FAILURE,
//   GET_GRN_REPORT_DOWNLOAD_REQUEST,
//   GET_GRN_REPORT_DOWNLOAD_SUCCESS,
//   GET_GRN_REPORT_FAILURE,
//   GET_GRN_REPORT_REQUEST,
//   GET_GRN_REPORT_SUCCESS,
// } from "./grnReportTypes";
import {
    GET_TRANSACTION_DOWNLOAD_FAILURE,
    GET_TRANSACTION_DOWNLOAD_REQUEST,
  GET_TRANSACTION_DOWNLOAD_SUCCESS,
  GET_TRANSACTION_REPORT_FAILURE,
  GET_TRANSACTION_REPORT_REQUEST,
  GET_TRANSACTION_REPORT_SUCCESS,
} from "./transactionReportTypes";
let baseUrl = Config.baseUrl;

const getTransactionReportRequest = () => {
  return {
    type: GET_TRANSACTION_REPORT_REQUEST,
  };
};

const getTransactionReportSuccess = (payload) => {
  return {
    type: GET_TRANSACTION_REPORT_SUCCESS,
    payload: payload,
  };
};

const getTransactionReportFailure = (error) => {
  return {
    type: GET_TRANSACTION_REPORT_FAILURE,
    payload: error,
  };
};

const getTransactionReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getTransactionReportRequest());
    let url = `${baseUrl}/reports/transaction?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTransactionReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTransactionReportFailure(err.response));
      });
  };
};

const downloadTransactionReportRequest = () => {
  return {
    type: GET_TRANSACTION_DOWNLOAD_REQUEST,
  };
};

const downloadTransactionReportSuccess = (payload) => {
  return {
    type: GET_TRANSACTION_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const downloadTransactionReportFailure = (error) => {
  return {
    type: GET_TRANSACTION_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const downloadTransactionReport = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadTransactionReportRequest());
    let url = `${baseUrl}/reports/transaction?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadTransactionReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadTransactionReportFailure(err.response));
      });
  };
};

export { getTransactionReport, downloadTransactionReport }; 
